/* eslint-disable */ 
import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Button, Divider } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import 'rc-slider/assets/index.css';
import Popover from '@material-ui/core/Popover';
import { AppTheme } from '../../styles/AppTheme';
import { adminData } from '../../data/AdminData.js'
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import { AppHelper } from '../../helpers/AppHelper';
import { AppConfig } from '../../AppConfig.js';

export class EventFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterPopover: null,
      priorityFilters: this.props.priorityFilters || Controller.get().userMgr().getPriorityFilters(),
      tagFilters: this.props.tagFilters || Controller.get().userMgr().getTagFilters(),
      tagKeyFilters: this.props.tagKeyFilters || [],
      filterTagValue: this.props.filterTagValue || {},
      searchItem:"",
      searchItemKey:""
    }
  }

  onChange = (event) => {
    this.setState({
      filterTagValue: { ...this.state.filterTagValue, [event.target.name]: event.target.value }
    })
  }
  
  // onSearchChange = (event) => {
  //   let tagFilters = this.state.tagFilters
  //   let idx = tagFilters.indexOf(this.state.searchItem)
  //   if (idx > -1) {
  //     if (event.target.value) {
  //       tagFilters[idx] = (event.target.value)
  //     } else {
  //       tagFilters.splice(idx, idx + 1)
  //     }
  //   } else {
  //     tagFilters.push((event.target.value))
  //   }

  //   this.setState({
  //     tagFilters: tagFilters,
  //     searchItem: (event.target.value)
  //   })
  // }


  // onSearchChange = (event) => {
  //   const searchValue = event.target.value;
    
  //   // If search is empty, clear any existing search filters
  //   if (!searchValue) {
  //     const tagFilters = this.state.tagFilters.filter(tag => 
  //       tag !== this.state.searchItem && 
  //       !this.state.searchItem.split(',').map(t => t.trim()).includes(tag)
  //     );
      
  //     this.setState({
  //       tagFilters,
  //       searchItem: ''
  //     });
  //     return;
  //   }
    
  //   // Process comma-separated tags
  //   const newTags = searchValue.split(',').map(tag => tag.trim()).filter(tag => tag);
    
  //   // Remove old search items from tagFilters
  //   let tagFilters = this.state.tagFilters.filter(tag => 
  //     tag !== this.state.searchItem && 
  //     !this.state.searchItem.split(',').map(t => t.trim()).includes(tag)
  //   );
    
  //   // Add new search tags
  //   tagFilters = [...tagFilters, ...newTags];
    
  //   // Remove duplicates
  //   tagFilters = [...new Set(tagFilters)];
    
  //   this.setState({
  //     tagFilters,
  //     searchItem: searchValue
  //   });
  // };

  onSearchChange = (event) => {
    const searchValue = event.target.value;
    let tagFilters = [...this.state.tagFilters]; 
    if (!searchValue) {
      
      if (this.state.searchItem) {
        const oldSearchTags = this.state.searchItem.split(',').map(tag => tag.trim()).filter(tag => tag);
        tagFilters = tagFilters.filter(tagArr => 
          !oldSearchTags.some(oldTag => tagArr[0] === oldTag)
        );
      }
      
      this.setState({
        tagFilters,
        searchItem: ''
      });
      return;
    }
    
    
    const newTags = searchValue.split(',').map(tag => tag.trim()).filter(tag => tag);
    
    
    if (this.state.searchItem) {
      const oldSearchTags = this.state.searchItem.split(',').map(tag => tag.trim()).filter(tag => tag);
      tagFilters = tagFilters.filter(tagArr => 
        !oldSearchTags.some(oldTag => tagArr[0] === oldTag)
      );
    }
    
    
    newTags.forEach(tag => {
      
      if (!tagFilters.some(tagArr => tagArr[0] === tag)) {
        tagFilters.push([tag]);
      }
    });
    
    this.setState({
      tagFilters,
      searchItem: searchValue
    });
  };

  onSearchKeyChange = (event) => {
    const searchValue = event.target.value;
    let tagKeyFilters = [...this.state.tagKeyFilters];

    if (!searchValue) {
      if (this.state.searchItemKey) {
        const oldSearchKeys = this.state.searchItemKey.split(',').map(key => key.trim()).filter(key => key);
        tagKeyFilters = tagKeyFilters.filter(key => !oldSearchKeys.includes(key));
      }

      this.setState({
        tagKeyFilters,
        searchItemKey: ''
      });
      return;
    }

    const newKeys = searchValue.split(',').map(key => key.trim()).filter(key => key);

    if (this.state.searchItemKey) {
      const oldSearchKeys = this.state.searchItemKey.split(',').map(key => key.trim()).filter(key => key);
      tagKeyFilters = tagKeyFilters.filter(key => !oldSearchKeys.includes(key));
    }

    newKeys.forEach(key => {
      if (!tagKeyFilters.includes(key)) {
        tagKeyFilters.push(key);
      }
    });

    this.setState({
      tagKeyFilters,
      searchItemKey: searchValue
    });
  };
  
  filterByPriority = (e, item) => {
    const index = this.state.priorityFilters.indexOf(item.value);
    const priorityFilter = this.state.priorityFilters

    if (index > -1) {
      priorityFilter.splice(index, 1);
    } else {
      priorityFilter.push(item.value);
    }

    this.setState({ priorityFilters: priorityFilter })
  }

  getFilterIndex = (item) => {
    const isTagKeyMode = this.props.orgData && this.props.orgData.settings &&
      this.props.orgData.settings.tagSettings &&
      this.props.orgData.settings.tagSettings.searchByTagKey === "YES";

    if (isTagKeyMode) {
      // For tag key mode, check if the key exists in tagKeyFilters
      const keyToCheck = Array.isArray(item.key) ? item.key[0] : item.key;
      return this.state.tagKeyFilters.indexOf(keyToCheck);
    } else {
      // For tag value mode, use the original logic
      return this.state.tagFilters.findIndex(tagFilter => {
        if (typeof item.key === 'string' && typeof tagFilter === 'string') {
          return tagFilter === item.key;
        }
        else if (Array.isArray(item.key) && Array.isArray(tagFilter)) {
          return tagFilter.length === item.key.length &&
            tagFilter.every((value, idx) => value === item.key[idx]);
        }
        return false;
      });
    }
  }

  filterByTags = (e, item) => {
    const isTagKeyMode = this.props.orgData && this.props.orgData.settings &&
      this.props.orgData.settings.tagSettings &&
      this.props.orgData.settings.tagSettings.searchByTagKey === "YES";

    if (isTagKeyMode) {
      // Tag Key mode: update tagKeyFilters
      let { tagKeyFilters } = this.state;
      const keyToToggle = Array.isArray(item.key) ? item.key[0] : item.key;
      const index = tagKeyFilters.indexOf(keyToToggle);
      const isRemoving = index !== -1;

      if (isRemoving) {
        tagKeyFilters.splice(index, 1);
      } else {
        tagKeyFilters.push(keyToToggle);
      }

      // Update searchItemKey to reflect all current tagKeyFilters
      const searchItemKey = tagKeyFilters.join(', ');

      this.setState({ tagKeyFilters, searchItemKey });
    } else {
      // Tag Value mode: update tagFilters (original behavior)
      let { tagFilters } = this.state;
      const index = this.getFilterIndex(item);
      const isRemoving = index !== -1;

      if (isRemoving) {
        tagFilters.splice(index, 1);
      } else {
        tagFilters.push(item.key);
      }

      // Update searchItem to reflect all current tagFilters
      const searchItem = tagFilters
        .filter(tag => Array.isArray(tag))
        .map(tagArr => tagArr[0])
        .join(', ');

      this.setState({ tagFilters, searchItem });
    }
  };

  applyFilter = () => {
    if (
      (this.state.priorityFilters && this.state.priorityFilters.length > 0)
      ||
      (this.state.tagFilters && this.state.tagFilters.length > 0)
      ||
      (this.state.tagKeyFilters && this.state.tagKeyFilters.length > 0)
    ) {
      this.setState({
        filterMode: true
      })
    } else {
      this.setState({
        filterMode: false
      })
    }
    this.closeFilterPopover()
    const updatedFilterTagValue = {}
    for (const f of this.state.tagFilters) {
      if (this.state.filterTagValue[f]) {
        updatedFilterTagValue[f] = this.state.filterTagValue[f]
         }
    }
    this.setState({
      filterTagValue: updatedFilterTagValue
    })
    this.props.filterHandler(this.state.tagFilters, this.state.priorityFilters, updatedFilterTagValue, this.state.searchItem, this.state.tagKeyFilters, this.state.searchItemKey)
  }

  renderFilterPopover = (id, open) => {
    const position = window.innerWidth > 767 ? 'right' : 'center'
    const tags = this.props.orgData && this.props.showTags?AppHelper.getTagsFromOrg(this.props.orgData) : this.props.place ? AppHelper.getTags(this.props.place.type) : []
    return (
      <Popover
        id={id}
        open={open}
        classes={{ paper: css(Styles.filterPopoverContainer) }}
        anchorEl={this.state.filterPopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: position,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: position,
        }}
        onClose={this.closeFilterPopover}
      >
        <div>
          <div className={css(Styles.filterContainerHeader)}>
            <p className={css(Styles.filterContentHeader)}>Filters</p>
          </div>

          <Divider className={css(Styles.divider)} />

          <div className={css(Styles.filterContent)}>
            <div className={css(Styles.filterInnerContent)}>
              <p className={css(Styles.filterIncidentTitle)}>by Priority</p>

              <div className={css(Styles.editAlert)}>
                {adminData.priorityValues.map((item, i) => {
                  return (
                    <div key={i} className={css(Styles.editAlertContainer, Styles.headerEditAlertContainer)}>
                      <div className={css(Styles.editAlertDotContainer, Styles.headerEditAlertDotContainer)}>
                        <div className={css(Styles.editAlertDotContent)} style={{ backgroundColor: item.color }} />
                      </div>

                      <div className={css(Styles.editAlertLabel, Styles.headerEditAlertLabel)}
                        onClick={(e) => this.filterByPriority(e, item)}
                        style={{
                          backgroundColor:
                            this.state.priorityFilters.indexOf(item.value) > -1 ?
                              item.color : AppTheme.primaryColor
                        }}
                      >
                        <p className={css(CommonStyles.margin)}>{item.label}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            {this.props.showTags && !(this.props.orgData && this.props.orgData.settings && this.props.orgData.settings.tagSettings && this.props.orgData.settings.tagSettings.searchByTagKey === "YES") && <div className={css(Styles.filterInnerContent)}>
              <p className={css(Styles.filterIncidentTitle)}> Search by Tag Value</p>

              <div className={css(Styles.filterSearchContainer)}>
                {adminData.searchValues.map((item, i) => {
                  return (
                    <div key={i} hidden={item.type == 'selector'}>
                      <TextField
                        placeholder={'e.g., CUSTOMER, EMPLOYEE (comma-separated)'}
                        value={this.state.searchItem}
                        onChange={e => this.onSearchChange(e)}
                        name={item.key}
                        fullWidth
                        className={css(Styles.filterSearchInput)}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: css(Styles.filterSearchInputField),
                          }
                        }}
                        InputLabelProps={{
                          classes: {
                            root: css(Styles.headerTextFieldContent),
                          }
                        }}
                      />
                    </div>
                  )
                })}
              </div>
            </div>}

            {this.props.orgData && this.props.orgData.settings && this.props.orgData.settings.tagSettings && this.props.orgData.settings.tagSettings.searchByTagKey && this.props.orgData.settings.tagSettings.searchByTagKey == "YES" && this.props.showTags && <div className={css(Styles.filterInnerContent)}>
              <p className={css(Styles.filterIncidentTitle)}> Search by Tag Key</p>

              <div className={css(Styles.filterSearchContainer)}>
                <TextField
                  placeholder={'e.g., treadmill, stair_climber (comma-separated)'}
                  value={this.state.searchItemKey}
                  onChange={e => this.onSearchKeyChange(e)}
                  name={'tagKey'}
                  fullWidth
                  className={css(Styles.filterSearchInput)}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: css(Styles.filterSearchInputField),
                    }
                  }}
                  InputLabelProps={{
                    classes: {
                      root: css(Styles.headerTextFieldContent),
                    }
                  }}
                />
              </div>
            </div>}


            {/* {tags && tags.length > 0 &&
              <Divider className={css(Styles.divider)} />
            } */}

            {tags && tags.length > 0 &&
              <div className={css(Styles.filterInnerContent)}>
                <p className={css(Styles.filterIncidentTitle)}>by Tag</p>

                <div className={css(Styles.editAlert, Styles.editAlertTag, Styles.tagsFont)}>
                  {tags.map((item, i) => {
                    return (
                      <div key={i} className={css(Styles.tagFilterOuterContainer)}>
                        <div className={css(Styles.tagFilterContainer)}>
                          <div className={css(Styles.headerTagContainer)}>
                            <div
                              className={ this.getFilterIndex(item) > -1 ?
                                css(Styles.filterTagButton) :
                                css(Styles.filterTagButton, Styles.filterTagButtonUnselected)}
                              onClick={(e) => this.filterByTags(e, item)}>
                              <p className={css(Styles.filterTagButtonText)}>{item.label ? item.label : item.key}</p>
                            </div>
                          </div>

                        <div hidden={item.type == 'selector'}>
                          <TextField
                            placeholder={'Enter Value'}
                            value={this.state.filterTagValue[item.key]}
                            onChange={e => this.onChange(e)}
                            name={item.key}
                            className={css(Styles.inputCssTextField)}
                            InputProps={{
                              disableUnderline: true,
                              classes: {
                                root: css(Styles.headerTextFieldContentInput),
                              }
                            }}
                            InputLabelProps={{
                              classes: {
                                root: css(Styles.headerTextFieldContent),
                              }
                            }}
                          />
                        </div>
                        </div>
                      </div>
                    )
                  })}
                </div>

              </div>
            }
            

            {this.props.showApplyFilters && <div className={css(Styles.saveFilterContainer)}>
              <div className={css(Styles.buttonContainer)}>
                <Button
                  variant='contained'
                  onClick={() => this.applyFilter()}
                  className={css(Styles.buttonStyle, Styles.buttonStyleApply)}>
                  APPLY
                </Button>
              </div>
            </div>}
          </div>

        </div>
      </Popover>
    )
  }

  showFilterPopover = (e) => {
    //////console.log('showFilterPopover')
    this.setState({ filterPopover: e.currentTarget })
  }

  closeFilterPopover = () => {
    this.setState({ filterPopover: null })
  }

  setFilterStyles = () => {
    if (this.state.filterMode) {
      return css(CommonStyles.headerMemberAddContainer, Styles.headerMemberStyle, Styles.headerMemberAddContainerSecondSpecific, Styles.filterModeOn)
    } else {
      return css(CommonStyles.headerMemberAddContainer, Styles.headerMemberStyle, Styles.headerMemberAddContainerSecondSpecific)
    }
  }

  render = () => {
    const filteropen = Boolean(this.state.filterPopover);
    const filterid = filteropen ? 'filter-popover' : undefined;

    return (
      <div>
        <Tooltip title={'FILTER EVENTS'}>
          <div
            onClick={(e) => this.showFilterPopover(e)}
            className={this.setFilterStyles()}>

            <img src={require('../../assets/images/filter.svg')} className={css(Styles.filterIcon)} />

            {/*<p className={css(Styles.switchControlLabel)}>FILTER</p>*/}
          </div>
        </Tooltip>
        {this.renderFilterPopover(filterid, filteropen)}
      </div>
    )
  }
}